import { StyledText, StyledTitle } from "../../../../style/typography";
import { ButtonStyled } from "../../../../style/button";
import { ProductCard } from "./style";

import "react-toastify/dist/ReactToastify.css";
import { iProductsProps } from "./@types";
import { useContext } from "react";
import { CartContext } from "../../../../providers/CartContext";

export const Product = ({ product }: iProductsProps) => {
  const { productAdd } = useContext(CartContext);

  return (
    <ProductCard>
      <div>
        <img src={product.img} alt={product.name} />
      </div>
      <div>
        <StyledTitle tag="heading3" titleStyle="heading3">
          {product.name}
        </StyledTitle>
        <StyledText tag="caption" textStyle="caption" color="#828282">
          {product.category}
        </StyledText>
        <StyledText weigth={600} tag="body" textStyle="body" color="#27AE60">
          R$ {product.price.toFixed(2)}
        </StyledText>
        <ButtonStyled
          onClick={() => productAdd(product)}
          weigth={600}
          buttonStyle="default"
        >
          Adicionar
        </ButtonStyled>
      </div>
    </ProductCard>
  );
};
